import React, { useEffect } from 'react';
export const LIST_SCROLL = 'listScroll';

export const useScrollPosition = (
    contentRef: React.RefObject<HTMLDivElement>,
) => {
    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        const savedY = sessionStorage.getItem(LIST_SCROLL);
        if (savedY !== null) {
            el.scrollTop = parseInt(savedY, 10);
        }
    }, [contentRef]);

    useEffect(() => {
        const el = contentRef.current;

        if (!el) {
            return;
        }

        const handleScroll = () => {
            sessionStorage.setItem(LIST_SCROLL, el.scrollTop.toString());
        };

        el.addEventListener('scroll', handleScroll);

        return () => {
            el.removeEventListener('scroll', handleScroll);
        };
    }, [contentRef]);
};
